// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__VJMRk"};